// extracted by mini-css-extract-plugin
export default {"icon":"ColorModeToggle_icon__XUCMx","dark":"ColorModeToggle_dark__Tw7Fg","light":"ColorModeToggle_light__W7LVd"};